import React, { useState, useEffect } from 'react';
import { AdaptiveModal } from '@/components/ui/AdaptiveModal';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';

export interface AddMealNoteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSave: (noteText: string) => void;
  isLoading?: boolean;
  mealType: 'breakfast' | 'lunch' | 'dinner';
}

const AddMealNoteDialog: React.FC<AddMealNoteDialogProps> = ({
  open,
  onOpenChange,
  onSave,
  isLoading = false,
  mealType
}) => {
  const [noteText, setNoteText] = useState('');

  const handleSave = () => {
    if (noteText.trim()) {
      onSave(noteText.trim());
      setNoteText('');
      onOpenChange(false);
    }
  };

  const handleCancel = () => {
    setNoteText('');
    onOpenChange(false);
  };

  const handleClose = () => {
    onOpenChange(false);
  };

  // Clear text when modal closes
  useEffect(() => {
    if (!open) {
      setNoteText('');
    }
  }, [open]);

  return (
    <AdaptiveModal
      isOpen={open}
      onClose={handleClose}
      title={`Add ${mealType.charAt(0).toUpperCase() + mealType.slice(1)} Note`}
      position="center" 
      size="md"
      scrollable={true}
    >
      <div className="space-y-4">
        <div>
          <Label htmlFor="note-text">What did you eat?</Label>
          <Textarea
            id="note-text"
            placeholder={`e.g., ${
              mealType === 'breakfast' 
                ? 'Cereal and milk, eggs and toast, smoothie and oatmeal...' 
                : mealType === 'dinner' 
                ? 'Pasta with tomato sauce, grilled chicken, takeout pizza...' 
                : 'Sandwich and chips, salad, leftover soup...'
            }`}
            value={noteText}
            onChange={(e) => setNoteText(e.target.value)}
            className="mt-1 focus-visible:ring-primary/20"
            autoFocus={false}
          />
        </div>
      </div>
      
      <div className="flex justify-end gap-2 mt-6">
        <Button variant="outline" onClick={handleCancel} disabled={isLoading}>
          Cancel
        </Button>
        <Button onClick={handleSave} disabled={!noteText.trim() || isLoading}>
          {isLoading ? 'Saving...' : 'Save Note'}
        </Button>
      </div>
    </AdaptiveModal>
  );
};

export default AddMealNoteDialog;